import styles from "./LargeTraitsHeading.module.css";

export default function LargeTraitsHeading(props: {
  title: string;
  noMobile?: boolean;
}) {
  return (
    <h1
      className={
        props.noMobile
          ? `${styles.heading} ${styles.noMobile}`
          : `${styles.heading}`
      }
    >
      {props.title}
    </h1>
  );
}
